import styled from 'styled-components';

import { useVideoLink } from '@/component/FileUpload/useVideoLink';

const IFrameContainerStyled = styled.div<{ $rounded?: boolean }>`
  width: 100%;
  aspect-ratio: 16/9;
  max-height: 440px;
  position: relative;
  border-radius: ${({ $rounded }) => ($rounded ? '12px' : '0px')};
  overflow: hidden;
`;

type FormRecordingVideoPreviewEmbedProps = { videoLink: string; rounded?: boolean };

export const FormRecordingVideoPreviewEmbed = ({ videoLink, rounded }: FormRecordingVideoPreviewEmbedProps): JSX.Element => {
  const { getEmbedUrlType } = useVideoLink();

  const embedUrl = getEmbedUrlType(videoLink).embedUrl;

  return (
    <IFrameContainerStyled $rounded={rounded}>
      <iframe
        src={embedUrl}
        allowFullScreen
        title="Video"
        style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
      />
    </IFrameContainerStyled>
  );
};
